<template>
  <div
    class="order-card-component"
    :class="{'filial-not-connected': isFilialNotConnected}"
  >
    <div class="status-container d-flex">
      <status
        :created-at="order.createdAt"
        :status="order.orderStatus"
        :order="order"
        @open-fast-order-on-mobile="showMobileMenu = !showMobileMenu"
      />
      <div v-if="isMobile" class="mobile-info d-flex flex-column">
        <span class="total-price">{{ order.totalPrice }} ₽</span>
        <div class="order-deadline-time">
          <font-awesome-icon icon="clock" class="mr-3" />
          <span class="font-weight-medium">~{{ getOrderDeadlineTime }} / {{ getOrderRemainingMinutes }}</span>
        </div>
        <div class="remaining-time-section d-flex flex-column">
          <order-dead-line-timer
            :dead-line="order.deadLine"
            :stopped-at="order.timerStoppedAt"
            :stop-reason="order.timerStopReason"
            @lateness="(value) => setOrderLateness(order.id, value)"
          />
          <template v-if="false && getOrderDeadlineTime">
            <span
              v-if="order.orderStatus !== 'completed' && order.orderStatus !== 'canceled'"
              class="timer font-weight-medium"
              :class="{'timer-negative': timeDifference < 0}"
            >
              {{ deadLineTime }}
            </span>
            <span
              v-if="order.orderStatus === 'completed' || order.orderStatus === 'canceled'"
              class="timer font-weight-medium"
              :class="{'timer-negative': timeDifference < 0}"
            >
              {{ deadLineTime }}
            </span>
            <span v-if="timeDifference >= 0" class="label">Осталось</span>
            <span v-if="timeDifference < 0" class="label">Опоздание</span>
          </template>
        </div>
      </div>
    </div>

    <div class="order-container flex flex-column">
      <order-details
        v-if="!isMobile"
        :order="order"
        @openCourierInfo="showCourierInfo = true"
        @updateStepperStatus="updateStepperStatus"
      />
      <stepper
        v-if="!isMobile"
        :statuses="getOrderStatuses"
        :is-lateness="order.isLateness"
        :is-preorder="order.isPreorder"
      />

      <div v-if="showOverlay" class="order-container-overlay"></div>
    </div>
    <transition name="fade" :duration="300">
      <courier-info
        v-if="showCourierInfo"
        :order="order"
        @changeStatus="changeStatus"
        @setAssemblyStatus="setAssemblyStatus"
        @setReadyStatus="setReadyStatus"
        @close="showCourierInfo = false"
      />
    </transition>

    <div class="mobile-menu-button">
      <v-btn
        fab
        depressed
        small
        @click="showMobileMenu = !showMobileMenu"
      >
        <font-awesome-icon :icon="showMobileMenu ? 'chevron-up' : 'chevron-down'" />
      </v-btn>
    </div>

    <div v-if="showMobileMenu" class="mobile-menu">
      <order-details
        :order="order"
        @openCourierInfo="showCourierInfo = true"
        @updateStepperStatus="updateStepperStatus"
      />
      <stepper
        :statuses="getOrderStatuses"
        :is-lateness="order.isLateness"
        :is-preorder="order.isPreorder"
      />
    </div>
  </div>
</template>

<script>
  import Status from './Status'
  import OrderDetails from './OrderDetails.vue'
  import Stepper from './Stepper'
  import CourierInfo from './CourierInfo'
  // import { DateTime, Duration } from 'luxon'
  import OrderDeadLineTimer from '@/components/order-card/OrderDeadLineTimer'
  import { formatIsoDateTimeAsTime } from '@/util/date-time-helper'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrderCard',
    components: {
      OrderDeadLineTimer,
      Status,
      OrderDetails,
      Stepper,
      CourierInfo,
    },
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
      status: {
        type: Object,
        default: () => {},
      },
    },
    data () {
      return {
        isStepperPositive: true,
        showCourierInfo: false,
        showMobileMenu: false,
        isMobile: false,
        deadLineTime: '00:00',
        deadLineTimeout: null,
        timeDifference: 0,
      }
    },
    computed: {
      ...mapGetters({
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
        isCallCenterUser: 'auth/isCallCenterUser',
      }),
      showOverlay () {
        return !!this.order?.activeCall
      },
      getOrderStatuses () {
        return this.order?.info?.changeStatuses || []
      },
      getOrderDeadlineTime () {
        return formatIsoDateTimeAsTime(this.order.deadLine, '')
      },
      getOrderRemainingMinutes () {
        return Math.ceil(this.order.basket.cookingAndDeliveryTime / 60) + ' мин'
      },
      isFilialNotConnected () {
        return this.indicateFilialConnectionStatus && this.isCallCenterUser && this.order?.filial?.isConnected === false
      },
    },
    mounted () {
      window.addEventListener('resize', this.checkIsMobile)
      this.checkIsMobile()
      /* if (this.order.orderStatus !== 'completed' && this.order.orderStatus !== 'canceled') {
        this.setTimer()
      } else {
        this.getRemainingTime()
      } */
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.checkIsMobile)
      // clearInterval(this.deadLineTimeout)
    },
    methods: {
      setOrderLateness (orderId, eventValue) {
        // console.log('-->>> setOrderLateness in order-card ', orderId, eventValue)
        this.$store.commit('orders/setOrderLateness', {
          id: orderId,
          value: eventValue,
        })
      },
      /* getRemainingTime () {
        if (!this.order.deadLineString) {
          return false
        }
        let completeDatatime = ''
        if (this.order.orderStatus === 'completed') {
          completeDatatime = DateTime.fromFormat(this.order.orderCompletedAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        } else {
          completeDatatime = DateTime.fromFormat(this.order.orderCanceledAt, 'yyyy-MM-dd HH:mm:ss').toMillis()
        }
        const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
        this.timeDifference = Duration.fromMillis(deadLine - completeDatatime).as('milliseconds')
        this.deadLineTime = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
        if (this.timeDifference < 0) {
          this.deadLineTime = `-${this.deadLineTime}`
        }
      }, */
      /* setTimer () {
        if (!this.order.deadLineString) {
          return false
        }
        const currentDatetime = DateTime.local().toMillis()
        const deadLine = DateTime.fromFormat(this.order.deadLineString, 'yyyy-MM-dd HH:mm:ss').toMillis()
        this.timeDifference = Duration.fromMillis(deadLine - currentDatetime).as('milliseconds')
        this.timeDifference = Math.round(this.timeDifference)
        clearInterval(this.deadLineTimeout)
        this.deadLineTimeout = setInterval(() => {
          const minutes = Duration.fromMillis(Math.abs(this.timeDifference)).toFormat('mm:ss')
          if (this.timeDifference < 0) {
            this.deadLineTime = `-${minutes}`
          } else {
            this.deadLineTime = `${minutes}`
          }
          this.timeDifference -= 1000
        }, 1000)
      }, */
      updateStepperStatus (value) {
        this.isStepperPositive = value
      },
      setAssemblyStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('setAssemblyStatus', id)
        }
      },
      setReadyStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('setReadyStatus', id)
        }
      },
      changeStatus (id) {
        if (this.order.orderStatus !== 'completed') {
          this.$emit('changeStatus', id)
        }
      },
      checkIsMobile () {
        this.isMobile = window.innerWidth <= 1024
      },
    },
  }
</script>

<style lang="less" scoped>
  //noinspection ALL
  .order-card-component {
    display: flex;
    align-items: flex-start;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 3px 6px #00000029;
    overflow: hidden;
    position: relative;
    z-index: 0;
    align-items: stretch;

    &.filial-not-connected {
      //box-shadow: 0 0 3px 2px @color-pink;
    }

    .order-container {
      position: relative;
      align-self: stretch;
      z-index: 0;
      justify-content: space-between;

      &-overlay {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(256, 256, 256, 0.75);
        z-index: 200;
        backdrop-filter: grayscale(100%);
      }

      /*&:after {
        content: '';
        position: relative;
        left: 0;
        bottom: 0;
        width: 100%;
        min-height: 42px;
        background-color: @color-secondary;
        z-index: -1;
      }*/
    }

    .mobile-menu-button {
      position: absolute;
      right: 5px;
      bottom: 5px;
      z-index: 1;
      display: none;
    }

    .mobile-menu {
      display: none;
      padding: 10px 5px;
    }

    .media-lg({
      display: flex;
      flex-direction: column;

      .status-container {
        width: 100%;
      }

      .order-container {
        &:after {
          display: none;
        }
      }

      .mobile-menu-button {
        display: block;
      }

      .mobile-info {
        padding: 10px 5px 10px 10px;
        width: 50%;
        justify-content: space-between;

        .total-price {
          font-size: 24px;
          margin-bottom: 10px;
        }

        .remaining-time-section {
          .timer {
            color: #1ee984;
            font-size: 20px;
          }

          .timer-negative {
            color: #E91E63;
          }
        }

        .order-deadline-time {
          margin-bottom: 10px;
        }
      }

      .mobile-menu {
        display: block;
        width: 100%;
      }
    })
  }
</style>
